import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=1131855b&"
import script from "./CompaniesTable.vue?vue&type=script&lang=ts&"
export * from "./CompaniesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports